import {RecordFailState, RedeemKycState, RedeemRecordState, RedeemResultCode} from "@/Core/Redeem/redeemEnum";


export class RedeemConfigEntity {
    isOk!: boolean;
    channelList!: ResponseRedeemConfigData[];

}

export class RedeemInfo {
    scBCount: number = 0; //总数量
    redeemBCount: number = 0; //可兑换数量
    unPlayedBCount: number = 0; //奖励数量
    minScB: number = 0; //最低兑换档位
    recordInfo!: RedeemRecordInfo;
    isCancel: boolean = false;
    isWithdrawal: boolean = false;
    isPaying: boolean = false;
}

export class RedeemResult {
    code!: RedeemResultCode;
    errorMessage: string = '';
    record!: ResponseRedeemApplyData;
}

export class RedeemRecordInfo {
    dollar: number = 0;
    fee: number = 0;
    dateTime: string = '';
    account: string = '';
    state!: RedeemRecordState;
    failState!: RecordFailState;
    id: string = '';
    channelType: number = 0;
    orderStatus: number = 0;
    kycState!: RedeemKycState;//KYC状态: 0-无需操作 1-待验证 2-处理中 3-通过 4-不通过 5-可重试	string
    kycUrl: string = '';
    comment: string = '';
}
